import React from 'react';
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import InfoBlock from "./InfoBlock";
import SuggestionBlock from "./SuggestionBlock";

const ArtistSuggestionsItemFormStep1 = ({initData, controlRef}) => {

    return (
        <BaseSimpleItemEditorForm>
            <SuggestionBlock
                initData={initData}
            />
            <InfoBlock>
                Убедитесь, что заявленное <b>ФИО&nbsp;Автора</b> содержит <u>корректное имя</u>
                <br/>
                <br/>
                Если указан посторонний текст или указанной информации недостаточно, то заявку следует удалить (кнопка <b>УДАЛИТЬ&nbsp;ЗАЯВКУ</b>)
                <br/>
                <br/>
                Если указано корректное имя, перейдите к следующему шагу (кнопка <b>ДАЛЕЕ</b>)
            </InfoBlock>
        </BaseSimpleItemEditorForm>
    );
};

export default ArtistSuggestionsItemFormStep1;